// Voices retired because Cartesia gave them non-Indian English accents
// (2026-09-30), mapped to their replacement. Screenings saved with an old id keep
// it; the agent swaps it at session start. Mapping on load here makes the picker
// show the voice candidates will actually hear, instead of snapping to the first
// option. Keep in sync with REPLACED_VOICE_IDS in livekit-agent/src/constants/voices.js.
const REPLACED_VOICE_IDS = {
  '4877b818-c7fe-4c89-b1cf-eadf8e23da72': '098fb15d-2597-4186-8b74-25340050b6e7', // Rohan -> Vishal
  '07bc462a-c644-49f1-baf7-82d5599131be': 'cf061d8b-a752-4865-81a2-57570a6e0565', // Sindhu -> Ramya
};

export const currentVoiceId = (id) => REPLACED_VOICE_IDS[id] || id;
